import '../styles/modal-card.css'
export default function ModalCard({ title, content }) {
    const onClose = () => {
        const modal = document.getElementById('modal');
        modal.classList.toggle('active', false);
    }
    
    return (
        <div id='modal' className="modal-card-backdrop" onClick={onClose}>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose}>
                    <img src='./images/39.png' alt="Close" />
                </button>
                <h2 className="modal-card-title gc-text">{title}</h2>
                <div className="modal-card-content">
                    {content}
                </div>
            </div>
        </div>
    )
}